<template>
  <section class="sec-weblog background-sec">
    <div class="sec-titr">
      <h1 class="sec-titr__title">مقالات</h1>
    </div>
      <div class="container-weblog-list">
    <ul class="weblog-list">
      <li
        class="weblog-item"
        v-for="weblog in listOfWeblogs"
        :key="weblog.title"
      >
        <img :src="require('../../../public/image/' + weblog.image)" class="weblog-item__image"/>
        <h2 class="weblog-item__title">{{ weblog.title }}</h2>
        <p class="weblog-item__text">{{ weblog.text }}</p>
        <router-link  :to="weblog.link" class="base-btn-2 weblog-item__link"> <i class="fas fa-arrow-right"></i> بیشتر</router-link>
      </li>
    </ul>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      listOfWeblogs: [
        {
          image: "detect.webp",
          title: "نحوه تشخیص عسل طبیعی از غیر طبیعی",
          text: "یکی از دغدغه‌های افراد هنگام خرید، به ویژه اگر به دنبال خواص درمانی عسل باشند، این است که آیا عسلی که می‌خرند واقعا طبیعی است یا خیر.",
          link:"/detect"
        },
        {
          image: "lemon.jpg",
          title: "عسل درمانی",
          text:"خاصیت بهبود بخشی داروها را چند برابر میکند،از این رو در بسیاری از محصولات آرایشی و بهداشتی استفاده میشود. ",
          link:"/medicinal"
        },
        {
          image: "about-us.jpg",
          title: "نحوه تولید عسل",
          text:"برای یک زنبوردار و یا کسی که با کار زنبورداری از نزدیک آشنا بوده است، قطعا پاسخ به این سوال که عسل چگونه تولید می شود و آیا عسل مدفوع زنبور عسل است یا خیر بسیار ساده است.",
          link:"/produce"
        },
      ],
    };
  },
};
</script>


<style></style>
